import React, { useState } from 'react';
import { Form, Input, Button, Card, message } from 'antd';
import { UserOutlined, LockOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { login } from '../services/api';
import './Login.css';

const Login = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const onFinish = async (values) => {
    setLoading(true);
    try {
      const response = await login(values);
      if (response.data.status === 'ok') {
        // 保存token到localStorage
        localStorage.setItem('token', response.data.data.token);
        message.success('ログイン成功');
        navigate('/news');
      } else {
        message.error(response.data.status || 'ログイン失敗');
      }
    } catch (error) {
      message.error('ログイン失敗：' + (error.response?.data?.status || 'ネットワークエラー'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <Card title="ニュース管理システムログイン" className="login-card">
        <Form
          name="login_form"
          initialValues={{ 
            remember: true,
            user: '',
            password: ''
          }}
          onFinish={onFinish}
        >
      <Form.Item
        name="user"
        rules={[{ required: true, message: 'ユーザー名を入力してください!' }]}
      >
        <Input 
          prefix={<UserOutlined className="site-form-item-icon" />} 
          placeholder="ユーザー名"
        />
      </Form.Item>

      <Form.Item
        name="password"
        rules={[{ required: true, message: 'パスワードを入力してください!' }]}
      >
        <Input
          prefix={<LockOutlined className="site-form-item-icon" />}
          type="password"
          placeholder="パスワード"
        />
      </Form.Item>

          <Form.Item>
            <Button 
              type="primary" 
              htmlType="submit" 
              className="login-form-button"
              loading={loading}
              block
            >
              ログイン
            </Button>
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
};

export default Login;
